import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/lang";

const META = {
    "/": {
        en: {
            title: "Star Group USA — Plumbing, Pumps & Electrical",
            desc: "Proven catalogue of pumps, plumbing and electrical appliances for U.S. trade professionals — dependable distribution and responsive support.",
        },
        es: {
            title: "Star Group USA — Plomería, Bombas y Eléctrico",
            desc: "Catálogo comprobado de bombas, plomería y aparatos eléctricos para profesionales de EE. UU. — suministro confiable y soporte receptivo.",
        },
    },
    "/about": {
        en: {
            title: "About Star USA — Our Story & Network",
            desc: "The story of Star USA — two decades of expertise, a USA head office and design centre, and sales offices across the UAE, Oman and Qatar.",
        },
        es: {
            title: "Sobre Star USA — Nuestra Historia y Red",
            desc: "La historia de Star USA — dos décadas de experiencia, una oficina principal y centro de diseño en EE. UU., y oficinas de ventas en EAU, Omán y Qatar.",
        },
    },
    "/products": {
        en: {
            title: "Products — The Star USA Catalogue",
            desc: "Browse the Star USA range — pumps, plumbing and electrical: mixers, showers, shattaf, flush fittings, seat covers, ancillaries, valves and PPR systems. Call to order.",
        },
        es: {
            title: "Productos — El Catálogo de Star USA",
            desc: "Explore la gama Star USA — bombas, plomería y eléctrico: mezcladoras, duchas, shattaf, mecanismos, tapas de inodoro, accesorios, válvulas y sistemas PPR. Llame para ordenar.",
        },
    },
    "/career": {
        en: {
            title: "Career at Star USA — Join the Team",
            desc: "Send your CV to info@stargroupusa.com — Star USA hires go-getters for its USA head office and sales offices in the UAE, Oman and Qatar.",
        },
        es: {
            title: "Carrera en Star USA — Únete al Equipo",
            desc: "Envíe su CV a info@stargroupusa.com — Star USA contrata personas con iniciativa para su oficina principal en EE. UU. y sus oficinas de ventas en EAU, Omán y Qatar.",
        },
    },
    "/contact": {
        en: {
            title: "Contact Star USA — Talk to Our Team",
            desc: "Call +1 737 337 7783 or email info@stargroupusa.com — head office in the USA, sales offices in the UAE, Oman and Qatar.",
        },
        es: {
            title: "Contacto Star USA — Hable con Nuestro Equipo",
            desc: "Llame al +1 737 337 7783 o escriba a info@stargroupusa.com — oficina principal en EE. UU., oficinas de ventas en EAU, Omán y Qatar.",
        },
    },
    "/404": {
        en: {
            title: "Page Not Found — Star USA",
            desc: "The page you are looking for does not exist. Return to the Star USA homepage.",
        },
        es: {
            title: "Página No Encontrada — Star USA",
            desc: "La página que busca no existe. Vuelva a la página de inicio de Star USA.",
        },
    },
};

function setMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

export default function Seo() {
    const { pathname } = useLocation();
    const { lang } = useLang();
    useEffect(() => {
        const key = pathname !== "/" ? pathname.replace(/\/+$/, "") : pathname;
        const known = Boolean(META[key]);
        const entry = META[key] || META["/404"];
        const meta = entry[lang] || entry.en;
        document.title = meta.title;
        setMeta("name", "description", meta.desc);
        setMeta("property", "og:title", meta.title);
        setMeta("property", "og:description", meta.desc);
        setMeta("name", "robots", known ? "index,follow" : "noindex,follow");
    }, [pathname, lang]);
    return null;
}
